<template>
  <StepperHead :steps="steps" :active="step" />
  <slot />
  <StepperNavButtons
    v-if="!disabled"
    :step="step"
    :lastStep="steps.length"
    :loading="loading"
    @next="$emit('next')"
    @back="$emit('back')"
  />
</template>

<script setup lang="ts">
defineProps<{
  steps: string[];
  step: number;
  loading: boolean;
  disabled?: boolean;
}>();

defineEmits(['next', 'back']);
</script>